// import { lazy, Suspense } from "react";
// import getEnv from "~/utils/get-env";

// interface ReCaptchaProps {
//   onChange?: (token: string | null) => void;
//   ref?: React.Ref<any>;
// }

// const ReCAPTCHAComponent = lazy(() => import("react-google-recaptcha").then((m) => ({ default: m.default })));

// export default function ReCaptchaV2({ onChange, ref }: ReCaptchaProps): React.ReactElement {
//   const env = getEnv();
//   const siteKey = env?.GOOGLE_RECAPTCHA_SITE_KEY || "";

//   if (!siteKey) {
//     console.warn("reCAPTCHA site key is not configured");
//     return <div className="relative z-10" />;
//   }

//   return (
//     <div className="relative z-10">
//       <Suspense fallback={<div className="h-20" />}>
//         <ReCAPTCHAComponent ref={ref} sitekey={siteKey} onChange={onChange} />
//       </Suspense>
//     </div>
//   );
// }

import { GoogleReCaptcha } from "react-google-recaptcha-v3";

interface ReCaptchaProps {
  refreshReCaptcha?: boolean;
  getCaptchaToken: (token: string) => void;
  action?: string;
}

export default function ReCaptcha({ refreshReCaptcha, getCaptchaToken, action }: ReCaptchaProps) {
  return <GoogleReCaptcha onVerify={getCaptchaToken} action={action} refreshReCaptcha={refreshReCaptcha} />;
}
